// REACT
import React, { useContext, RefObject, useRef, MouseEvent, useEffect } from 'react'

// ESTILOS
import Styles from './Gallery.module.css'

// CONTEXTO
import MainContext from 'Context/MainContext'

// ASSETS
import BackGround from 'Assets/Booking/booking-header.jpg'

// COMPONENTES
import CloseButton from 'Components/CloseButton/CloseButton'

// HERRAMIENTAS
import { getImage } from 'Utils/Storage'
import { ScrollToTop } from 'Hooks/Hooks'

const Gallery: React.FC = () => {
	// CONTEXTO
	const { gallery } = useContext(MainContext).lang

	// REFERENCIAS
	const viewContainerRef: RefObject<HTMLDivElement> = useRef(null)
	const viewCloseBtn: RefObject<HTMLButtonElement> = useRef(null)
	const mainContainer: RefObject<HTMLDivElement> = useRef(null)
	const viewRef: RefObject<HTMLImageElement> = useRef(null)
	const backRef: RefObject<HTMLImageElement> = useRef(null)

	// MOSTRAR VIEWER
	const showViewer = () => {
		// VERIFICAR ELEMENTOS
		if (viewContainerRef.current && viewCloseBtn.current) {
			// ANIMACIONES
			viewCloseBtn.current.style.transition = 'opacity 0.3s ease-in-out 0.3s'
			viewCloseBtn.current.style.opacity = '1'
			viewContainerRef.current.style.transition =
				'background 0.3s ease-in-out 0.3s, transform 0.3s ease-in-out'
			viewContainerRef.current.style.transform = 'scale(1)'
			viewContainerRef.current.style.background = 'rgba(0, 0, 0, .7)'
		}
	}

	// OCULTAR VIEWER
	const hideViewer = () => {
		// VERIFICAR ELEMENTOS
		if (viewContainerRef.current && viewCloseBtn.current) {
			// ANIMACIONES
			viewCloseBtn.current.style.transition = 'opacity 0.3s ease-in-out 0s'
			viewCloseBtn.current.style.opacity = '0'
			viewContainerRef.current.style.transition =
				'background 0.3s ease-in-out 0s, transform 0.3s ease-in-out 0.3s'
			viewContainerRef.current.style.background = 'transparent'
			viewContainerRef.current.style.transform = 'scale(0)'

			// CAMBIAR A LOADING
			setTimeout(() => {
				if (viewRef.current) viewRef.current.src = require('Assets/General/loading.gif')
			}, 600)
		}
	}

	// IMAGENES
	const imgs: string[] = []
	for (let i = 0; i < 22; i++) imgs[i] = require(`Assets/Gallery/0${i}.jpg`)

	// LINKS
	const openLinks = imgs.map(
		(_path: string, index: number) => (ev: MouseEvent<HTMLImageElement>) => {
			// CAMBIAR RUTA
			getImage(`0${index}.jpg`).then((url: string) => {
				if (viewRef.current) viewRef.current.src = url
			})

			// CAMBIAR ORIGIN
			if (viewContainerRef.current)
				viewContainerRef.current.style.transformOrigin = `${ev.clientX}px ${ev.clientY}px`

			// MOSTRAR VIEWER
			showViewer()
		}
	)

	useEffect(() => {
		// EFECTO
		const parallax = () => {
			if (backRef.current)
				backRef.current.style.transform = `translateY(-${window.scrollY * 0.3}px)`
		}

		// AGREGAR EVENTO
		window.addEventListener('scroll', parallax)

		// QUITAR EVENTO
		return () => window.removeEventListener('scroll', parallax)
	}, [])

	// SUBIR SIEMPRE
	ScrollToTop('')

	return (
		<section ref={mainContainer} className='page'>
			<div className={Styles.header}>
				<img src={BackGround} className={Styles.background} ref={backRef} alt='Background' />
				<h1 className={Styles.title}>{gallery.title}</h1>
				<p className={Styles.text}>{gallery.text}</p>
			</div>
			<div className={Styles.gallery}>
				<div className={Styles.grid}>
					{imgs.map((path: string, key: number) => (
						<img
							onClick={openLinks[key]}
							className={Styles.galleryItem}
							src={path}
							alt={`Gallery ${key}`}
							key={key}
						/>
					))}
				</div>
			</div>

			<div className={Styles.viewer} ref={viewContainerRef}>
				<CloseButton className={Styles.viewerBtn} action={hideViewer} btnRef={viewCloseBtn} />
				<img
					className={Styles.image}
					src={require('Assets/General/loading.gif')}
					alt='Gallery Full'
					ref={viewRef}
				/>
			</div>
		</section>
	)
}

export default Gallery
